// Компонент индикатора статуса

import { CheckCircle, XCircle, AlertTriangle } from 'lucide-react';
import type { StatusIndicatorProps } from '../../types';
import './Results.css';

export function StatusIndicator({ status, children, icon }: StatusIndicatorProps) {
  const defaultIcons = {
    success: <CheckCircle className="status-indicator__icon" />,
    danger: <XCircle className="status-indicator__icon" />,
    warning: <AlertTriangle className="status-indicator__icon" />,
  };

  return (
    <div className={`status-indicator status-indicator--${status}`}>
      {icon || defaultIcons[status]}
      <span>{children}</span>
    </div>
  );
}
